import { render, staticRenderFns } from "./Changes.vue?vue&type=template&id=fc938516&"
import script from "./Changes.vue?vue&type=script&lang=js&"
export * from "./Changes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports